import { Directive, forwardRef } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, Validator } from "@angular/forms";

import { OBG_VALIDATORS } from "../validators/validators";

@Directive({
	selector: "[obgNumeric]",
	providers: [
		{
			provide: NG_VALIDATORS,
			// eslint-disable-next-line @angular-eslint/no-forward-ref
			useExisting: forwardRef(() => NumericValidatorDirective),
			multi: true,
		},
	],
})
export class NumericValidatorDirective implements Validator {
	validate(control: AbstractControl): { numeric: boolean } | null {
		return OBG_VALIDATORS.numeric(control);
	}
}
